import Sales from '../../services/sales'
export default {
    data(){
        return{

            status:undefined
        }
    },
    mounted(){
        this.updateOrderStatus();
    },
    computed:{
        order(){
            return this.$route.query.id;
        }
    },
    methods:{
        updateOrderStatus(){
            Sales.updateSenffOrder(this.order).then(res=>{
                this.status = res;
                this.goToRequests();
            });
        },
        goToRequests(){
          this.$router.push({ name: 'requests' });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/external/retorno-senff.js